import styled from 'styled-components';
import { Row, Col } from 'antd';
import { maxWidth1300 } from 'Utils/utilsStyle';

const Wrapper = styled.div`
  overflow: hidden;
  padding-top: 20px;
  .profile-left{
    display:flex;
    flex-direction:column;
    justify-items: center;
    position:relative;
    &:after {
      content: "";
      width: 1px;
      height: 92%;
      position: absolute;
      right: 0px;
      top: 0px;
      background-color: #F5F1EA;
    }
    .image-box{
      width: 252px;
      height:252px;
      border-radius:50%;
      margin: 0 auto 36px auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 200px;
        height: 200px;
        margin: 0 auto 25px auto;
      }
    }
    .title-box{
      width: 70%;
      height:30px;
      border-radius:25px;
      margin: 0 auto;
      margin-bottom:20px;
      + .title-box{
        width: 55%;
      }
    }
    .title-small-box{
      border-radius:25px;
      margin: 5px auto 5px auto;
      width: 40%;
      height:18px;
    }
    .btn-box{
      border-radius:25px;
      margin: 20px auto;
      width: 90px;
      height:40px;
    }
  }
  .profile-right{
    padding: 0 45px;
    .button-box{
      width:100%;
      height:45px;
      margin-bottom:30px;
      border-radius:8px;
    }
    .title-small-box{
      height:20px;
      width:50%;
    }
    .number-box{
      width:100%;
      height:100px;
      border-radius:7px;
      margin-bottom: 20px;
      box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
      @media all and (-webkit-device-pixel-ratio: 1.25) {
        height: 80px;
        margin-bottom: 5px;
      }
    }
    .description-box{
      width:100%;
      height:100px;
      border-radius:7px;
      margin-top: 10px;
      margin-bottom: 34px;
    }
    .graph-box{
      width:100%;
      height:230px;
      border-radius:7px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 175px;
      }
      @media all and (max-width: ${maxWidth1300}) {
        height: 227px;
      }
    }
    .users-row{
      .people-overlap-wrapper{
        position: relative;
        margin: 10px 0;
        z-index: 0;
        .user-box{
          width:70px;
          height:70px;
          border-radius:50%;
          + .user-box {
            margin-left:-16px;
          }
          @media all and (max-width: ${maxWidth1300}){
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 8px;
    width: 50px;
  }
`;

export const CompetitorsAndExecutivesSkeleton = function () {
  return (
    <Row>
      <Col span={12}>
        <div className="users-row">
          <span className="skeleton-box title-small-box" />
          <div className="people-overlap-wrapper">
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
          </div>
          <span className="skeleton-box title-small-box" />
        </div>
      </Col>
      <Col span={12}>
        <div className="users-row">
          <span className="skeleton-box title-small-box" />
          <div className="people-overlap-wrapper">
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
            <span className="skeleton-box user-box" />
          </div>
          <span className="skeleton-box title-small-box" />
        </div>
      </Col>
    </Row>
  );
};

const CompanyCardSkeleton = function CompanyCardSkeleton() {
  return (
    <Wrapper>
      <Row>
        <Col xxl={{ span: 6 }} xl={{ span: 8 }} lg={{ span: 8 }}>
          <div className="profile-left">
            <span className="skeleton-box image-box" />
            <span className="skeleton-box title-box" />
            <span className="skeleton-box title-box" />
            <span className="skeleton-box title-small-box" />
            <span className="skeleton-box title-small-box" />
            <span className="skeleton-box title-small-box" />
            <span className="skeleton-box btn-box" />
          </div>
        </Col>
        <Col xxl={{ span: 18 }} xl={{ span: 16 }} lg={{ span: 16 }} className="h-100">
          <div className="profile-right">
            <span className="skeleton-box button-box" />
            <span className="skeleton-box title-small-box" style={{ marginBottom: '10px' }} />
            <Row gutter={14}>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={8}>
                    <span className="skeleton-box number-box" />
                  </Col>
                  <Col span={8}>
                    <span className="skeleton-box number-box" />
                  </Col>
                  <Col span={8}>
                    <span className="skeleton-box number-box" />
                  </Col>
                  <Col span={12}>
                    <span className="skeleton-box number-box" />
                  </Col>
                  <Col span={12}>
                    <span className="skeleton-box number-box" />
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <span className="skeleton-box graph-box" />
              </Col>
            </Row>
            <span className="skeleton-box description-box" />
            {
              CompetitorsAndExecutivesSkeleton()
            }
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default CompanyCardSkeleton;
